import { ChevronDown } from "react-feather";
import styles from "../creditreport.module.css";

const MultiGoalCell = ({ goals, expanded, onToggle }) => {
    if (goals.length === 1) {
        return (
            <div className={styles.singleGoalInline}>
                <span className={styles.miniBarBg}>
                    <span className={styles.miniBarFill} style={{ width: `${goals[0].pct}%` }} />
                </span>
                <span className={styles.singleGoalLabel}>{goals[0].pct}% · {goals[0].label}</span>
            </div>
        );
    }

    return (<div className={styles.multiGoalTrigger}>
        <span className={styles.goalCountPill}>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
                <circle cx="6" cy="6" r="5" stroke="#534AB7" strokeWidth="1.4" />
                <path d="M6 3.5v3l2 1.2" stroke="#534AB7" strokeWidth="1.3" strokeLinecap="round" />
            </svg>
            {goals.length} goals
        </span>
        <button
            className={styles.goalExpandBtn}
            onClick={(e) => { e.stopPropagation(); onToggle(); }}
            aria-expanded={expanded}
            aria-label={expanded ? "Hide goals" : "Show goals"}
        >
            {expanded ? "Hide" : "Show"} goals
            <span className={`${styles.goalChevron}${expanded ? " " + styles.open : ""}`}>
                <ChevronDown size={13} />
            </span>
        </button>
    </div>);
}

export default MultiGoalCell;